import { IconCheck } from '@/components/icons/IconCheck';
import { cn } from '@/lib/utils/tw-merge';

type VehicleFilterCheckProps = {
    label: string;
    checked: boolean;
    onChange: () => void;
    /** Live number of hits; left out on the reset row. */
    count?: number;
    className?: string;
};

/** A native checkbox under a drawn box: Tab and Space stay the browser's own. */
export function VehicleFilterCheck({ label, checked, onChange, count, className }: VehicleFilterCheckProps) {
    return (
        <label className={cn('vehicle-filter-check label-sm', className)}>
            <input type="checkbox" className="vehicle-filter-check__input" checked={checked} onChange={onChange} />
            <span className="vehicle-filter-check__box" aria-hidden="true">
                <IconCheck className="vehicle-filter-check__tick" />
            </span>
            <span className="vehicle-filter-check__label">{label}</span>
            {count !== undefined ? <span className="vehicle-filter-check__count label-xs">{count}</span> : null}
        </label>
    );
}
